export default __webpack_public_path__ + "static/754-b56287ea66b3fb7b4d263bf61364b2da.gif";